import React, { useEffect, useState } from "react";
import { Layout, Menu } from "antd";
import Config from "../../../config/Config";
import { Link, useLocation } from "react-router-dom";
import LogoComponent from "../Components/LogoComponent";
import { AppstoreOutlined, DashboardOutlined, BarcodeOutlined, TeamOutlined, SolutionOutlined,ImportOutlined  } from "@ant-design/icons";
import { camelCaseString } from "../../../config/Global";
import  UsersManagement from "../../../assets/images/icon/Users-management.svg?react";
import  Roles from "../../../assets/images/icon/Roles.svg?react";
import  Races from "../../../assets/images/icon/races.svg?react";
import  Cms from "../../../assets/images/icon/cms.svg?react";
import  Home from "../../../assets/images/icon/home.svg?react";
import  Setting from "../../../assets/images/icon/setting.svg?react";
import  StatusManagement from "../../../assets/images/icon/Status-management.svg?react";
import  InterestAssessment from "../../../assets/images/icon/Interest-Assessment.svg?react";
import  SkillAssessment from "../../../assets/images/icon/Skill-Assessment.svg?react";
import  TrainingLocations from "../../../assets/images/icon/VR-Training-Locations.svg?react";

import MenuBG from "../../../../src/assets/images/menu_bg.png";
import { useAppSelector } from "../../../utils/hooks/hooks";
import { CurriculumFiles } from "../../../config/Constant";

interface AppSidebarViewProps {
  collapsed: boolean;
}

/**
 * Renders the sidebar view component for the main layout a logo and 
 * containing the menu items.
 *
 * @param {AppSidebarViewProps} props - The props for the component.
 * @param {boolean} props.collapsed - Indicates whether the sidebar is collapsed.
 * @return {ReactElement} The rendered sidebar view component.
 */
const SidebarView: React.FC<AppSidebarViewProps> = ({ collapsed }) => {
  const userDetail = useAppSelector(state => state.auth.userDetail);
  const location = useLocation();
  const [menu, setMenu] = useState<any>([]);
  const [openMenu, setOpenMenu] = useState<any>([]);

  const defaultMenuIcon = <AppstoreOutlined />;

  const svgIcons: any = {
    Dashboard: <DashboardOutlined />,
    Settings: <Setting />,
    UsersManagement: <UsersManagement />,
    Roles: <Roles />,
    Ethnicities: <Races />,
    Cms: <Cms />,
    HomePage: <Home />,
    VeteranStatus: <StatusManagement />,
    VrTrainingLocations: <TrainingLocations />,
    InterestAssessment: <InterestAssessment />,
    SkillAssessment: <SkillAssessment />,
    Customers: <TeamOutlined />,
    AccessCodes: <BarcodeOutlined />,
    Curriculum: <SolutionOutlined />,
    Logs : <ImportOutlined  />,   
  };

  const AppMenu = (
    menu_item: any,
    open: any = [],
    parentKey: any = null
  ): any => {
    return menu_item
      ? Object.keys(menu_item).map(key => {
        var item: any = menu_item[key];
        if (item.children) {
          return {
            key: item.id + "",
            url: item.path,
            label: item.label,
            icon:
              svgIcons[camelCaseString(item.label).replaceAll(" ", "")] ??
              defaultMenuIcon,
            children: AppMenu(item.children, open, item.id + ""),
          };
        } else {
          if (
            location.pathname == item.path &&
            openMenu.length <= 0 &&
            parentKey
          ) {
            if (open.length === 0) {
              open.push(parentKey);
            }
            setOpenMenu(open);
          }


          /* CUSTOMER DASHBOARD CHANGES */
          let dashboardpath = item.path;
          if (
            item.path == '/' &&
            [
              '/customer/dashboard',
              '/new-dashboard',
              '/dashboard-1'
            ].includes(location.pathname)
          ) {
            dashboardpath = location.pathname;
          }
          /* CUSTOMER DASHBOARD CHANGES   */

          if (item.label === "Curriculum") {
            const customItem: any = {};
            console.log('item', customItem.children);
            customItem.children = []
            customItem.children = [...customItem.children, ...CurriculumFiles.map((data: any) => {
            return {
                key: data.id,
                label: <Link title={data.name} to={'curriculum/' + data.id}>{data.name}</Link>,
                url: 'curriculum/' + data.id,
              }
            })]
            customItem.icon = svgIcons[camelCaseString(item.label).replaceAll(" ", "")] ?? defaultMenuIcon;
            customItem.key = dashboardpath;
            customItem.url = item.path;
            customItem.label = item.label
            return customItem;


          }




          return {
            key: dashboardpath,
            url: item.path,
            label: <Link to={item.path}>{item.label}</Link>,
            //  title: item.label,
            icon:
              svgIcons[camelCaseString(item.label).replaceAll(" ", "")] ??
              defaultMenuIcon,
          };
        }
      })
      : null;
  };

  useEffect(() => {
    var customMenu = userDetail?.menu;
    const menuItemsTemp = AppMenu(customMenu);
    console.log('menuItemsTemp', menuItemsTemp);

    setMenu(menuItemsTemp);
  }, [userDetail, location]);

  return (
    <Layout.Sider
      collapsed={collapsed}
      width={Config.sidebar_width}
      className="main__page__appsidebar"
      style={{ backgroundImage: `url(${MenuBG})` }}
    >
      <LogoComponent collapsed={collapsed} />
      <Menu
        mode="inline"
        theme="dark"
        // activeKey={location.pathname}
        selectedKeys={[location.pathname]}
        items={menu}
        openKeys={openMenu}
        onOpenChange={openKeys => {
          setOpenMenu(openKeys);
        }}
      />
    </Layout.Sider>
  );
};

export default SidebarView;